import { Component, Inject, OnInit } from '@angular/core';
import { SafeHtml, DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Environment } from 'src/app/classes/environment';
import { AuthenticationService, AuthResult } from 'src/app/services/authentication.service';
import { CustomerService } from 'src/app/services/customer.service';
import { MyReCaptchaService } from 'src/app/services/my-recaptcha.service';

@Component({
	selector: 'data-confirmation',
	templateUrl: './data-confirmation.component.html',
	styleUrl: './data-confirmation.component.scss'
})
export class DataConfirmationComponent implements OnInit {

	bInProgress = false;

	bDataConfirmNeeded = false;
	isDataConfirmed = false;
	bUnfoldedDataProtection = false;

	bUserTermsConfirmNeeded = false;
	isTermsConfirmed = false;
	bUnfoldedTerms = false;

	firmaLabel = '';
	firmaKuerzel = '';
	bLoading = false;
	bError = false;
	privacyPolicyHtml: SafeHtml = "";
	termsOfUseHtml: SafeHtml = "";

	logoSrc: SafeUrl = "";


	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private myReCaptchaService: MyReCaptchaService,
		@Inject( "environment" ) private environment: Environment,
		private customerService: CustomerService,
		private domSanitizer: DomSanitizer
	) {
		this.bDataConfirmNeeded = this.environment.features.datenschutz;
		this.bUserTermsConfirmNeeded = this.environment.features.nutzungsbedingungen;
	}

	ngOnInit(): void {

		this.firmaLabel = this.environment.texts?.firma?.label || ''; //HIER
		this.firmaKuerzel = this.environment.texts?.kuerzel?.label || ''; //HIER

		this.logoSrc = this.customerService.getLoadedLogo();

		if( this.bDataConfirmNeeded || this.bUserTermsConfirmNeeded ) {

			this.bLoading = true;
			this.customerService.loadLegalInformation().subscribe( data => {
	
				this.bLoading = false;
				this.bError = !data;
				if( data ) {
					this.termsOfUseHtml = this.domSanitizer.bypassSecurityTrustHtml( data.termsOfUse );	
					this.privacyPolicyHtml = this.domSanitizer.bypassSecurityTrustHtml( data.privacyPolicy );	
				}
	
			} );

		}

	}


	confirmDataProtection() {
		this.isDataConfirmed = !this.isDataConfirmed;
	}

	confirmTermsOfUse() {
		this.isTermsConfirmed = !this.isTermsConfirmed;
	}

	confirm() {
		this.bInProgress = true;

		this.myReCaptchaService.getToken('confirmAction').subscribe(recaptchaToken => {
			if (!recaptchaToken) {
				window.alert("RECAPTCHA ERROR");
				this.bInProgress = false;
				return;
			}

			this.authenticationService.login(
				this.authenticationService.getTmpUserId(),
				this.authenticationService.getTmpPassword(),
				true,
				true,
				recaptchaToken
			).subscribe(result => {
				this.bInProgress = false;

				if (result === AuthResult.twoFaActivationRequired) {
					this.router.navigate(['/E2FA']);
				} else if (result === AuthResult.secondStepNeeded) {
					this.router.navigate(['/login']);
				} else {
					this.router.navigate(['/']);
				}
			});
		});
	}
}